import React from 'react'
import './FooterComponent.css'

const FooterComponent = () => {
    return (
        <footer>
            <div className="row m-0 p-0 background-footer" id="footer">
                <div className="col-12 mt-5 px-3">
                    <div className="row">
                        {/* Primer columna */}
                        <div className="col-lg-9 col-md-8 col-sm-12">
                            <div className="text-start mb-0">
                                <p className='mb-0 text-start text-p-footer'>En caso de reporte de eventos adversos o quejas de calidad relacionadas con nuestros productos, contactarse con: <a href="mailto:colombia-safety@novonordisk.com" className='text-decoration-none text-white'>colombia-safety@novonordisk.com</a></p>
                                <p className='text-p-footer mb-0 text-start mt-2'>© Copyright 2024 – Novo Nordisk <br/>
                                    La información contenida en esta plataforma es segmentada de acuerdo con el perfil profesional del usuario. Su distribución u otros usos se encuentran estrictamente prohibidos. Material revisado y aprobado por la Dirección Médica de Asuntos Regulatorios de Novo Nordisk
                                    Colombia S.A.S. NIT: 900.557.75-3. Derechos reservados 2024 CO24CD00010</p>

                                <p className='text-p-footer mt-3 mb-0 text-start'>
                                    Con el fin de garantizar una comunicación adecuada sobre nuestros productos, aclaramos que Novo Nordisk no incentiva ni aprueba ningún tipo de publicación mediática o por otro medio que no sea de carácter científico y dirigido al cuerpo médico sobre el uso de nuestras
                                    moléculas para indicaciones que aún no están incluidas en nuestro etiquetado y, por lo tanto, aún no están aprobadas por el Instituto Nacional de Vigilancia de Medicamentos y Alimentos (INVIMA). Siendo así, reiteramos que las noticias o publicaciones con este contenido
                                    no son respaldadas por Novo Nordisk. Si tiene alguna pregunta sobre nuestras moléculas, por favor diríjase al siguiente canal para obtener información adicional: contáctenos a través del correo <a href="mailto:infomedicacol@novonordisk.com" className='text-decoration-none text-white'>infomedicacol@novonordisk.com.</a>

                                </p>

                                <p className='fw-bold mt-1' style={{fontSize: '15px'}}>CO24RYB00081</p>
                            </div>
                        </div>
                        {/* Segunda columna con imagen */}
                        <div className="col-lg-3 col-md-4 col-sm-12 d-flex align-items-center justify-content-center">
                            <img src="QR-Logo.png" alt="Descripción de la imagen" className="img-fluid mb-5" />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default FooterComponent;